import React, { Component } from 'react';
import classNames from 'classnames';
import Paging from './Paging.react.js';
let i18n = require("i18next");

export default class MenuItemModal extends Component {
    render() {
        return (
        <div className="modal" id="menuitem-modal">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" aria-hidden="true"></button>
                        <h4 className="modal-title">{i18n.t("pos.table.item.status.label")}</h4>
                    </div>
                    <div className="modal-body">
                        <div className="menuitem-info">
                        </div>
                        <div className="menuitem-status">
                            <ul className="nav nav-tabs">
                                <li className="active">
                                    <a href="#menuitem-modal-status" data-toggle="tab" style={{color: "#5F6772"}}>
                                        {i18n.t("pos.table.item.status.label")}
                                    </a>
                                </li>
                                <li>
                                    <a href="#menuitem-modal-cancel" data-toggle="tab" style={{color: "#FF7B7B"}}>
                                        {i18n.t("pos.table.item.refund.label")}
                                    </a>
                                </li>
                            </ul>

                            <div className="tab-content">
                                <div className="tab-pane active" id="menuitem-modal-status"></div>
                                <div className="tab-pane" id="menuitem-modal-cancel"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/react/common/MenuItemModal.react.js